import { Box, Chip, Stack, Typography } from '@mui/joy';
import type { ScheduleEntry } from '@/types/dashboard';

interface ScheduleListItemProps {
  entry: ScheduleEntry;
  showEmployee?: boolean;
}

export default function ScheduleListItem({ entry, showEmployee = true }: ScheduleListItemProps) {
  const startTime = new Date(entry.start_datetime).toLocaleTimeString('en-US', {
    hour: 'numeric',
    minute: '2-digit',
  });
  const endTime = new Date(entry.end_datetime).toLocaleTimeString('en-US', {
    hour: 'numeric',
    minute: '2-digit',
  });
  const dateStr = new Date(entry.start_datetime).toLocaleDateString('en-US', {
    weekday: 'short',
    month: 'short',
    day: 'numeric',
  });

  return (
    <Box
      sx={{
        p: 1.5,
        border: '1px solid',
        borderColor: 'divider',
        borderRadius: 'sm',
        borderLeft: '4px solid',
        borderLeftColor: entry.shift_type_color,
      }}
    >
      <Stack direction="row" justifyContent="space-between" alignItems="center">
        <Stack direction="row" alignItems="center" spacing={1} sx={{ minWidth: 0 }}>
          <Box>
            <Typography level="body-sm" fontWeight="lg" noWrap>
              {showEmployee
                ? `${entry.employee_first_name} ${entry.employee_last_name}`
                : dateStr}
            </Typography>
            <Stack direction="row" spacing={0.5} alignItems="center">
              <Box
                sx={{
                  width: 8,
                  height: 8,
                  borderRadius: '50%',
                  bgcolor: entry.shift_type_color,
                  flexShrink: 0,
                }}
              />
              <Typography level="body-xs" color="neutral">
                {entry.shift_type_name} &middot; {startTime} – {endTime}
              </Typography>
            </Stack>
          </Box>
        </Stack>
        <Chip
          size="sm"
          variant="soft"
          color={entry.status === 'published' ? 'success' : entry.status === 'updated' ? 'primary' : 'warning'}
        >
          {entry.status}
        </Chip>
      </Stack>
    </Box>
  );
}
